/*
 * Belowzero – Custom Anpassungen
 * ------------------------------------------------------------
 * 1) Sticky Cart: Sichtbarkeit beim Scrollen + Live-Update der
 *    Artikelanzahl.
 * 2) Header-Sprachumschaltung: Popout oeffnen/schliessen (siehe
 *    Begruendung weiter unten).
 * 3) Sticky Add to Cart (Produktseite): Ein-/Ausblenden der Leiste
 *    und Spiegeln des echten Produktformulars.
 * Getrennt von theme.js / theme-extend.min.js gehalten, damit
 * Theme-Updates unabhaengig moeglich bleiben. Drei unabhaengige
 * IIFEs, damit ein fruehes "return" im einen Block (z.B. wenn
 * der Sticky-Cart-Button auf einer Seite fehlt) die anderen
 * Bloecke nicht mit abbricht.
 *
 * Umgesetzt von Justen Klemm, August 2026.
 * ------------------------------------------------------------
 */
(function () {
  "use strict";

  var stickyCart = document.querySelector("[data-sticky-cart]");
  if (!stickyCart) {
    return;
  }

  var SHOW_AFTER_PX = 400;
  var countEl = stickyCart.querySelector("[data-sticky-cart-count]");
  var liveEl = stickyCart.querySelector("[data-sticky-cart-live]");

  /* ---------------------------------------------------------
   * 1. Sichtbarkeit beim Scrollen
   * (eigener, rAF-gedrosselter Listener - unabhaengig vom
   * bestehenden Theme-JS, damit zukuenftige Theme-Updates die
   * Sticky-Cart-Logik nicht versehentlich mitbrechen koennen)
   * --------------------------------------------------------- */
  var ticking = false;

  function updateVisibility() {
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;
    stickyCart.classList.toggle("is-visible", scrolled > SHOW_AFTER_PX);
    ticking = false;
  }

  function onScroll() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  updateVisibility();

  /* ---------------------------------------------------------
   * 2. Artikelanzahl live halten
   * Reagiert auf die vom Theme bereits ausgeloesten Cart-Events
   * und synchronisiert Zaehler + Badge ueber /cart.js.
   * --------------------------------------------------------- */
  function refreshCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var count = cart.item_count || 0;
        stickyCart.classList.toggle("sticky-cart--has-items", count > 0);
        if (countEl) {
          countEl.textContent = count;
        }
        if (liveEl) {
          var word =
            count === 1
              ? liveEl.dataset.wordSingular
              : liveEl.dataset.wordPlural;
          liveEl.textContent = word ? count + " " + word : count;
        }
      })
      .catch(function () {
        /* Netzwerkfehler: Zaehler bleibt beim zuletzt bekannten Stand */
      });
  }

  ["theme:cart:update", "theme:cart:added"].forEach(function (eventName) {
    document.addEventListener(eventName, refreshCount);
  });

  /* ---------------------------------------------------------
   * 3. Waehrend der Cart-Drawer offen ist, Sticky-Cart-Button
   * ausblenden, damit er nicht ueber dem Drawer schwebt.
   * --------------------------------------------------------- */
  document.addEventListener("theme:cart:open", function () {
    stickyCart.classList.add("sticky-cart--drawer-open");
  });
  document.addEventListener("theme:cart:close", function () {
    stickyCart.classList.remove("sticky-cart--drawer-open");
  });
})();

/* ---------------------------------------------------------
 * Header-Sprachumschaltung: Popout oeffnen/schliessen
 * ------------------------------------------------------------
 * Das Theme initialisiert sein generisches Popout-JS
 * (data-popout / data-popout-toggle / data-popout-list /
 * data-popout-option / data-popout-input, siehe theme.js) nur
 * fuer einzelne Section-Typen (u.a. "footer", "product-template",
 * "featured-product") - die "header"-Section ist NICHT darunter.
 * Deshalb blieb ein Klick auf das Sprach-Icon im Header bisher
 * wirkungslos (Root Cause fuer "es oeffnet sich kein Dropdown").
 *
 * Diese Umsetzung ist bewusst auf ".header-language-switcher"
 * beschraenkt, repliziert nur das noetige Verhalten (oeffnen /
 * schliessen per Klick, Klick ausserhalb, Escape, Sprachwahl ->
 * Formular absenden) und ruehrt weder theme.js noch die
 * bestehende Popout-Klasse an, damit ein spaeteres Theme-Update
 * diese Logik nicht versehentlich ueberschreiben kann.
 * ----------------------------------------------------------- */
(function () {
  "use strict";

  var languageSwitchers = document.querySelectorAll(
    ".header-language-switcher [data-popout]"
  );
  if (!languageSwitchers.length) {
    return;
  }

  var POPOUT_VISIBLE_CLASS = "select-popout__list--visible";

  Array.prototype.forEach.call(languageSwitchers, function (popout) {
    var toggle = popout.querySelector("[data-popout-toggle]");
    var list = popout.querySelector("[data-popout-list]");
    var input = popout.querySelector("[data-popout-input]");
    var options = popout.querySelectorAll("[data-popout-option]");

    if (!toggle || !list) {
      return;
    }

    function isOpen() {
      return list.classList.contains(POPOUT_VISIBLE_CLASS);
    }

    function closePopout() {
      list.classList.remove(POPOUT_VISIBLE_CLASS);
      toggle.setAttribute("aria-expanded", "false");
    }

    function openPopout() {
      list.classList.add(POPOUT_VISIBLE_CLASS);
      toggle.setAttribute("aria-expanded", "true");
    }

    toggle.addEventListener("click", function (event) {
      event.preventDefault();
      if (isOpen()) {
        closePopout();
      } else {
        openPopout();
      }
    });

    Array.prototype.forEach.call(options, function (option) {
      option.addEventListener("click", function (event) {
        event.preventDefault();
        if (input) {
          input.value = option.getAttribute("data-value") || "";
        }
        closePopout();
        var form = popout.closest("form");
        if (form) {
          form.submit();
        }
      });
    });

    /* Klick ausserhalb schliesst das Popout wieder. */
    document.addEventListener("click", function (event) {
      if (isOpen() && !popout.contains(event.target)) {
        closePopout();
      }
    });

    /* Escape schliesst das Popout und gibt den Fokus zurueck. */
    popout.addEventListener("keyup", function (event) {
      if (event.key === "Escape" || event.code === "Escape") {
        closePopout();
        toggle.focus();
      }
    });

    /* Fokus verlaesst das Popout komplett (z.B. per Tab) -> schliessen. */
    popout.addEventListener("focusout", function (event) {
      if (!popout.contains(event.relatedTarget)) {
        closePopout();
      }
    });
  });
})();

/* ---------------------------------------------------------
 * Sticky Add to Cart (Produktseite)
 * ------------------------------------------------------------
 * Die Leiste (snippets/sticky-add-to-cart.liquid) ist bewusst nur
 * eine Spiegelung des echten Produktformulars:
 *
 * - Klick auf den Leisten-Button loest einen Klick auf dem echten
 *   "In den Warenkorb"-Button aus. theme.js hoert global auf Klicks
 *   auf "[data-add-to-cart]" und uebernimmt von dort alles Weitere
 *   (AJAX-Warenkorb, Ladezustand, Fehlermeldungen, Cart-Drawer,
 *   "Benachrichtige mich"-Popup bei ausverkauften Varianten). So wird
 *   keine Cart-Logik dupliziert und kuenftige Theme-Updates aendern
 *   das Verhalten automatisch mit.
 * - Preis, Vergleichspreis, Variantenname, Button-Text und
 *   Ausverkauft-/Ladezustand werden live vom echten Formular
 *   uebernommen, damit die Leiste nie einen anderen Stand anzeigt
 *   als die Seite selbst.
 * - Sichtbar wird die Leiste erst, wenn der echte Button nach oben
 *   aus dem Sichtbereich gescrollt ist (klassisches Verhalten).
 * ----------------------------------------------------------- */
(function () {
  "use strict";

  var bar = document.querySelector("[data-sticky-atc]");
  if (!bar) {
    return;
  }

  var productSection = document.querySelector(
    '[data-section-type="product-template"]'
  );
  var realButton =
    productSection && productSection.querySelector("[data-add-to-cart]");

  /* Ohne echtes Produktformular (z.B. Sonderlayout) bleibt die Leiste
     bewusst unsichtbar, statt einen wirkungslosen Button zu zeigen. */
  if (!realButton) {
    return;
  }

  var stickyButton = bar.querySelector("[data-sticky-atc-button]");
  var stickyButtonText = bar.querySelector("[data-sticky-atc-button-text]");
  var stickyPrice = bar.querySelector("[data-sticky-atc-price]");
  var stickyComparePrice = bar.querySelector("[data-sticky-atc-compare-price]");
  var stickyVariant = bar.querySelector("[data-sticky-atc-variant]");

  var realButtonText = realButton.querySelector("[data-add-to-cart-text]");
  var realPrice = productSection.querySelector("[data-product-price]");
  var realComparePrice = productSection.querySelector("[data-compare-price]");
  var realFormWrapper = realButton.closest("[data-form-wrapper]");

  /* ---------------------------------------------------------
   * 1. Klick an den echten Button weiterreichen
   * Der Button wird beim Klick neu gesucht, damit es auch dann
   * funktioniert, falls das Theme das Formular irgendwann neu
   * rendert und den urspruenglichen Button ersetzt.
   * --------------------------------------------------------- */
  if (stickyButton) {
    stickyButton.addEventListener("click", function () {
      if (stickyButton.disabled) {
        return;
      }
      var currentButton = productSection.querySelector("[data-add-to-cart]");
      if (currentButton) {
        currentButton.click();
      }
    });
  }

  /* ---------------------------------------------------------
   * 2. Zustand des echten Formulars spiegeln
   * --------------------------------------------------------- */
  function syncButton() {
    if (realButtonText && stickyButtonText) {
      stickyButtonText.textContent = realButtonText.textContent.trim();
    }
    if (stickyButton) {
      stickyButton.disabled = realButton.hasAttribute("disabled");
      stickyButton.classList.toggle(
        "is-loading",
        realButton.classList.contains("is-loading")
      );
    }
    if (realFormWrapper) {
      bar.classList.toggle(
        "sticky-atc--soldout",
        realFormWrapper.classList.contains("variant--soldout") ||
          realFormWrapper.classList.contains("variant--unavailabe")
      );
    }
  }

  function syncPrice() {
    if (realPrice && stickyPrice) {
      stickyPrice.innerHTML = realPrice.innerHTML.trim();
    }
    if (realComparePrice && stickyComparePrice) {
      /* trim() ist hier wichtig: ohne Vergleichspreis soll das Element
         wirklich leer sein, damit die CSS-Regel ".sticky-atc__price-compare:empty
         { display: none }" greift und kein leerer Durchstreich-Rest steht. */
      stickyComparePrice.innerHTML = realComparePrice.innerHTML.trim();
    }
  }

  if (window.MutationObserver) {
    new MutationObserver(syncButton).observe(realButton, {
      attributes: true,
      attributeFilter: ["disabled", "class"],
      childList: true,
      subtree: true,
      characterData: true,
    });

    if (realFormWrapper) {
      new MutationObserver(syncButton).observe(realFormWrapper, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    [realPrice, realComparePrice].forEach(function (element) {
      if (element) {
        new MutationObserver(syncPrice).observe(element, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    });
  }

  /* Variantenname kommt aus dem Theme-eigenen Event. */
  document.addEventListener("theme:variant:change", function (event) {
    var variant = event.detail ? event.detail.variant : null;
    if (stickyVariant) {
      stickyVariant.textContent = variant && variant.title ? variant.title : "";
    }
    syncButton();
    syncPrice();
  });

  syncButton();
  syncPrice();

  /* ---------------------------------------------------------
   * 3. Sichtbarkeit: erst wenn der echte Button nach oben aus dem
   * Sichtbereich gescrollt ist. Zusaetzlich wird die Hoehe der
   * Leiste als CSS-Variable gesetzt, damit der schwebende
   * Warenkorb-Button darueber rutschen kann (siehe
   * belowzero-custom.css, Abschnitt 3).
   *
   * Bewusst ein rAF-gedrosselter Scroll-Listener statt eines
   * IntersectionObservers (wie beim Sticky Cart weiter oben): ein
   * IntersectionObserver meldet sich nur, wenn sich der Schnitt mit
   * dem Sichtbereich aendert. Bei Spruengen - Ankerlinks,
   * wiederhergestellte Scroll-Position beim Zurueck-Navigieren,
   * "nach oben"-Sprung - kann der Button dabei komplett
   * uebersprungen werden (von "unterhalb" direkt nach "oberhalb"),
   * die Leiste bliebe dann faelschlich unsichtbar. Getestet und
   * reproduziert in test/run-sticky-atc-test.js.
   * --------------------------------------------------------- */
  var atcTicking = false;

  function measureHeight() {
    document.documentElement.style.setProperty(
      "--sticky-atc-height",
      bar.offsetHeight + "px"
    );
  }

  function setVisible(visible) {
    bar.classList.toggle("is-visible", visible);
    document.body.classList.toggle("has-sticky-atc", visible);
    if (visible) {
      measureHeight();
    }
  }

  function updateVisibility() {
    /* Sichtbar, sobald der echte Button vollstaendig nach oben aus dem
       Bild gescrollt ist. Ist er (z.B. bei aktivierter "sticky form"
       Option) dauerhaft sichtbar, bleibt die Leiste aus. */
    setVisible(realButton.getBoundingClientRect().bottom < 0);
    atcTicking = false;
  }

  function onAtcScroll() {
    if (atcTicking) {
      return;
    }
    atcTicking = true;
    window.requestAnimationFrame(updateVisibility);
  }

  window.addEventListener("scroll", onAtcScroll, { passive: true });
  document.addEventListener("theme:resize", updateVisibility);

  measureHeight();
  updateVisibility();
})();